import { Liquid } from 'liquidjs';

export default class ExtendedLiquid extends Liquid {
  constructor(options?: any) {
    super(options);
    this.registerFilter('currencyMillions', ExtendedLiquid.currencyMillions);
  }

  static currencyMillions(
    value: number | null | undefined,
    kForHundredThousands: boolean = false,
    accounting: boolean = false,
    nearestWhole: boolean = false,
    fallbackDoDollarsOnLargeDecimals: boolean = false,
  ): string {
    if (value === null || value === undefined) {
      return '';
    }

    let absValue = Math.abs(value);

    let formattedValue;

    const precision = (val: number, nearestWhole: boolean) => {
      if (nearestWhole) {
        return val.toFixed(0);
      }

      // Only strip trailing zeros after the decimal point
      const formatted = val.toPrecision(8);
      // Only remove trailing zeros if there's a decimal point
      if (formatted.includes('.')) {
        return formatted.replace(/0+$/, '').replace(/\.$/, '');
      }
      return formatted;
    };

    if (nearestWhole) {
      absValue = parseInt(precision(absValue, nearestWhole));
    } else {
      absValue = parseFloat(precision(absValue, nearestWhole));
    }

    if (absValue >= 10000 && absValue < 1000000 && kForHundredThousands) {
      formattedValue = `$${absValue / 1000}k`;
    } else if (absValue >= 1000000) {
      formattedValue = `$${absValue / 1000000}m`;
    } else {
      formattedValue = new Intl.NumberFormat('en-AU', {
        style: 'currency',
        currency: 'AUD',
        maximumFractionDigits: nearestWhole ? 0 : 2,
      }).format(absValue);

      // Remove .00 but keep significant decimals like .50
      if (!nearestWhole && formattedValue.endsWith('.00')) {
        formattedValue = formattedValue.replace('.00', '');
      }
    }

    if (fallbackDoDollarsOnLargeDecimals) {
      if ((formattedValue.match(/\.(\d+)m/)?.[1]?.length || 0) >= 3) {
        formattedValue = new Intl.NumberFormat('en-AU', {
          style: 'currency',
          currency: 'AUD',
          maximumFractionDigits: 0,
        }).format(absValue);
      }

      if (formattedValue.match(/\.(\d+)k/)?.[1]?.replace(/0+$/, '')?.length || 0 >= 2) {
        formattedValue = new Intl.NumberFormat('en-AU', {
          style: 'currency',
          currency: 'AUD',
          maximumFractionDigits: 0,
        }).format(absValue);
      }
    }

    if (value < 0) {
      return accounting ? `(${formattedValue})` : `-${formattedValue}`;
    }

    if (absValue === 0) {
      return formattedValue;
    }

    return formattedValue;
  }
}
